import { LANGS } from "@/lib/i18n";
import { STATUS_COLORS } from "@/lib/helpers";
import { t } from "@/lib/i18n";

export const BrandMark = ({ className = "h-9" }) => (
  <img src="/logo-mark.png" alt="M-Line" className={`${className} w-auto rounded-md object-contain`} />
);

export const BrandLogo = ({ className = "h-16" }) => (
  <img src="/logo.png" alt="M-Line Solutions" className={`${className} w-auto rounded-lg object-contain`} data-testid="brand-logo" />
);

export function LangSwitch({ lang, setLang }) {
  return (
    <div className="flex rounded-full border border-white/10 bg-black/30 p-0.5" data-testid="lang-switch">
      {LANGS.map((l) => (
        <button
          key={l}
          type="button"
          onClick={() => setLang(l)}
          data-testid={`lang-${l}-btn`}
          className={`rounded-full px-2.5 py-1 font-mono text-[11px] uppercase transition-colors ${
            lang === l ? "bg-blue-600 text-white" : "text-slate-400 hover:text-white"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
}

export function StatusBadge({ status, lang = "ro", testId }) {
  const color = STATUS_COLORS[status] || "#64748B";
  return (
    <span
      data-testid={testId || "status-badge"}
      className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-0.5 font-mono text-[11px] uppercase tracking-wider"
      style={{ color, borderColor: `${color}55`, background: `${color}18` }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: color }} />
      {t(lang, `status_${status}`)}
    </span>
  );
}
